var _circle, _circle2, _g, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.604 17a11.698 11.698 0 0 0-8.192 3.383A11.501 11.501 0 0 0 21 28.507c0 1.27.206 2.533.611 3.739.146.395.438.72.817.907.38.188.816.225 1.222.104a1.631 1.631 0 0 0 .99-2.022 7.48 7.48 0 0 1-.451-2.93 8.255 8.255 0 0 1 1.494-4.493 8.36 8.36 0 0 1 3.725-2.953 8.439 8.439 0 0 1 4.748-.457 8.396 8.396 0 0 1 4.229 2.189 8.283 8.283 0 0 1 2.336 4.123 8.23 8.23 0 0 1-.314 4.72 8.308 8.308 0 0 1-2.862 3.784 8.415 8.415 0 0 1-4.482 1.619s-1.624.101-2.439.202a8.42 8.42 0 0 0-.888.173.11.11 0 0 1-.143-.01.108.108 0 0 1-.01-.141l.255-1.364 1.528-6.866a1.564 1.564 0 0 0-.22-1.186 1.6 1.6 0 0 0-2.198-.464 1.576 1.576 0 0 0-.69.994s-3.64 16.761-3.64 16.913a1.518 1.518 0 0 0 .639 1.636c.174.116.37.196.577.234a1.565 1.565 0 0 0 1.205-.206 1.544 1.544 0 0 0 .68-1.007c.051-.202.51-2.426.51-2.426a4.077 4.077 0 0 1 1.197-2.141 4.135 4.135 0 0 1 2.217-1.078c.35-.05 1.827-.152 1.827-.152a11.63 11.63 0 0 0 7.647-3.862 11.441 11.441 0 0 0 2.875-8.018 11.456 11.456 0 0 0-3.471-7.783A11.647 11.647 0 0 0 32.604 17Zm2.586 26.205a1.897 1.897 0 0 0-1.96.81c-.14.209-.236.443-.285.69a1.89 1.89 0 0 0 .803 1.969c.21.139.446.234.693.28a1.846 1.846 0 0 0 1.965-.801c.137-.212.23-.45.272-.699a1.974 1.974 0 0 0-1.489-2.249Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVDot);
export default __webpack_public_path__ + "static/media/vDot.fc812b303ce16141e92b08d95a4d132e.svg";
export { ForwardRef as ReactComponent };